export default "__VITE_ASSET__CdPMTNVH__"